/* eslint-disable no-param-reassign */
import { call, put, select } from 'redux-saga/effects';
import { initCQ as initCQAda, extendCQ as extendCQAda } from '@bitComponents/adabyron/cqv2';
import { 
  CQ_ACTION_CODES, 
  TEXT_TYPES_CODES,
} from '../catalogConstants';
import { getProductOfferingTextByType } from '../utils/general';
import { WEB_SERVICES } from './webServices';
import { PRODUCT_TYPES, getProductTypeByProductOfferingTypes } from '../utils/catalog';
import { WEBSERVICE_ERRORS } from '../errorManagement/errorCatalog';

const contextStore = state => state.context.data;

// NEW CODE

const filterSelectionsFirstLevel = (customerQuoteItems, forcedInitialFirstLevelActionIfNecessary = null) => {
  let customerQuoteItemsToReturn = null;
  
  if(customerQuoteItems.length > 1 && forcedInitialFirstLevelActionIfNecessary ) {
    const forcedChoice = customerQuoteItems.find((customerQuoteItem) => customerQuoteItem.actionId === forcedInitialFirstLevelActionIfNecessary);
    if(forcedChoice){
      customerQuoteItemsToReturn = [forcedChoice];
    }
  }
  if(!customerQuoteItemsToReturn){
    customerQuoteItemsToReturn = customerQuoteItems.filter((customerQuoteItem) => {
      const { actionId } = customerQuoteItem;
      return (
        actionId === CQ_ACTION_CODES.REGISTER
        || actionId === CQ_ACTION_CODES.MIGRATION
        || actionId === CQ_ACTION_CODES.PORTABILITY
        || actionId === CQ_ACTION_CODES.ACTIVATE_LINE
        || actionId === CQ_ACTION_CODES.UPGRADE_INCLUDED_LINE
        || actionId === CQ_ACTION_CODES.BUY
      );
    });
  }
  return customerQuoteItemsToReturn;
};

const filterSelectionsSecondLevel = (customerQuoteItems, forcedAction) => {
  const customerQuoteItemsToReturn = customerQuoteItems.filter((customerQuoteItem) => {
    const { actionId } = customerQuoteItem;
    if(forcedAction){
      return actionId === forcedAction;
    }
    return (
      actionId === CQ_ACTION_CODES.REGISTER
      || actionId === CQ_ACTION_CODES.MIGRATION
      || actionId === CQ_ACTION_CODES.PORTABILITY
      || actionId === CQ_ACTION_CODES.KEEP
    );
  });

  return customerQuoteItemsToReturn;
};

export const findProductOfferingById = (obj, id) => {
  // Caso base: si el objeto es null o undefined, o si no es un objeto, retornamos null.
  if (!obj || typeof obj !== 'object') {
    return null;
  }

  // Buscamos en todas las propiedades del objeto.
  // eslint-disable-next-line no-restricted-syntax
  for (const prop in obj) {
    // eslint-disable-next-line no-prototype-builtins
    if (obj.hasOwnProperty(prop)) {
      const val = obj[prop];
      // Si encontramos un objeto llamado "productOffering" con una propiedad "id" igual al valor buscado, lo retornamos.
      if (prop === 'productOffering' && val.id === id) {
        return val;
      }
      // Si el valor es otro objeto, hacemos una búsqueda en profundidad recursivamente.
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const found = findProductOfferingById(val, id);
      if (found) {
        return found;
      }
    }
  }

  // Si no encontramos el objeto buscado, retornamos null.
  return null;
};

/**
 * Método que normaliza las selecciones de cliente del api para poder ser usadas en vista
 * @param {*} selections Selecciones que puede hacer el cliente sobre la oferta
 * @returns Selecciones del cliente normalizadas
 */
export const getSimpleClientOptionsForUI = (apiOptions) => {
  const options = [];
  const migrationPhones = [];
  const keepPhones = [];
  let thereIsPortability = false;
  let thereAreMultipleMigrationOptions = false;
  let thereAreMultipleKeepOptions = false;
  let newDescription = null;
  let newProductOfferingName = '';
  if (Array.isArray(apiOptions) && apiOptions.length > 0) {
    const { description, productOfferingName } = apiOptions[0];
    newDescription = description;
    newProductOfferingName = productOfferingName;

    if (!newDescription && apiOptions[0].productOffering) { // TODO Creo que esto ya no se usa, porque no existe productOffering aquí
      newDescription = getProductOfferingTextByType(
        apiOptions[0].productOffering,
        TEXT_TYPES_CODES.BRIEF,
      );
    }
    if(!newProductOfferingName && apiOptions[0].productOffering){ // TODO Creo que esto ya no se usa, porque no existe productOffering aquí
      newProductOfferingName = getProductOfferingTextByType(
        apiOptions[0].productOffering,
        TEXT_TYPES_CODES.ORDINARY,
      );
    }
    apiOptions.forEach((option) => {
      const { actionId, clientPhoneNumberToBeAppliedTo, cqsiId } = option;

      if (actionId === CQ_ACTION_CODES.PORTABILITY) {
        thereIsPortability = true;
      }

      if (actionId !== CQ_ACTION_CODES.MIGRATION && actionId !== CQ_ACTION_CODES.KEEP) {
        const newOption = {
          actionId,
          description: newDescription,
          productOfferingName: newProductOfferingName,
          cqsiId,
        };

        if (clientPhoneNumberToBeAppliedTo) {
          newOption.clientPhoneNumber = clientPhoneNumberToBeAppliedTo;
        }
        options.push(newOption);
      } else if (clientPhoneNumberToBeAppliedTo) {

        if (actionId === CQ_ACTION_CODES.MIGRATION) {
          migrationPhones.push({
            label: clientPhoneNumberToBeAppliedTo,
            value: clientPhoneNumberToBeAppliedTo,
          });
        }
        if (actionId === CQ_ACTION_CODES.KEEP) {
          keepPhones.push({
            label: clientPhoneNumberToBeAppliedTo,
            value: clientPhoneNumberToBeAppliedTo,
          });
        }
      }
    });
  }
  if (migrationPhones.length > 0) {
    options.push({
      actionId: CQ_ACTION_CODES.MIGRATION,
      phoneOptions: migrationPhones,
      description: newDescription,
      productOfferingName: newProductOfferingName,
    });
  }

  if (keepPhones.length > 0) {
    options.push({
      actionId: CQ_ACTION_CODES.KEEP,
      phoneOptions: keepPhones,
      description: newDescription,
    });
  }

  if (migrationPhones.length > 1) {
    thereAreMultipleMigrationOptions = true;
  }

  if (keepPhones.length > 1) {
    thereAreMultipleKeepOptions = true;
  }

  return {
    options,
    thereIsPortability,
    thereAreMultipleMigrationOptions,
    thereAreMultipleKeepOptions,
  };
};

const getMainClientOptionsForUI = (apiOptions) => {
  const { options, thereIsPortability } = getSimpleClientOptionsForUI(apiOptions);

  let mainOptionSelected = null;
  if (Array.isArray(apiOptions) && apiOptions.length === 1 && !thereIsPortability) {
    mainOptionSelected = apiOptions[0].actionId;
  }

  return {
    options,
    thereIsPortability,
    mainOptionSelected,
  };
};

const orderChoiceGroups = (group, group2) => {
  if (group.customerQuoteItems
    && group.customerQuoteItems.length === 1
    && group.customerQuoteItems[0].actionId === CQ_ACTION_CODES.MIGRATION) {
    return -1;
  }
  if (group2.customerQuoteItems
    && group2.customerQuoteItems.length === 1
    && group2.customerQuoteItems[0].actionId === CQ_ACTION_CODES.MIGRATION) {
    return 1;
  }
  if (group.canBeUnselectable && !group2.canBeUnselectable) {
    return 1;
  }
  if (!group.canBeUnselectable && group2.canBeUnselectable) {
    return -1;
  }
  return 0;
};

const getSecondaryClientOptionsForUI = (secondaryOptionsGroup, allowNoActionOptions = true, mainProductType) => {
  const secondaryOptionsGroupForUI = {};
  let needToAskForSecondaryOptions = false;
  Object.keys(secondaryOptionsGroup).forEach((secondaryKey) => {
    const { parentActionId, choiceGroups } = secondaryOptionsGroup[secondaryKey];

    const newChoiceGroups = [];
    const newKeepGroups = [];

    choiceGroups.forEach((choiceGroup) => {
      const { canBeUnselectable, id } = choiceGroup;
      const {
        options: customerQuoteItems,
        thereIsPortability,
        thereAreMultipleMigrationOptions,
        thereAreMultipleKeepOptions,
      } = getSimpleClientOptionsForUI(choiceGroup.customerQuoteItems);

      let mustAskClient = false;

      if (
        customerQuoteItems.length > 1 ||
        thereIsPortability ||
        thereAreMultipleMigrationOptions ||
        thereAreMultipleKeepOptions ||
        mainProductType === PRODUCT_TYPES.MULTI_SIM
      ) {
        mustAskClient = true;
        needToAskForSecondaryOptions = true;
      }

      const isNotOnlyKeepGroup = customerQuoteItems.filter(customerQuoteItem => customerQuoteItem.actionId !== CQ_ACTION_CODES.KEEP);
      const isNotOnlyMigrationGroup = customerQuoteItems.filter(customerQuoteItem => customerQuoteItem.actionId !== CQ_ACTION_CODES.MIGRATION);

      if (isNotOnlyKeepGroup.length === 0 || isNotOnlyMigrationGroup.length === 0) {
        newKeepGroups.push({
          customerQuoteItems,
          id,
          canBeUnselectable,
          mustAskClient,
        });
      } else {
        if (canBeUnselectable && allowNoActionOptions) {
          const newCustomerQuoteItem = {
            actionId: CQ_ACTION_CODES.NO_ACTION,
            description: customerQuoteItems[0].description,
            productOfferingName: customerQuoteItems[0].productOfferingName,
          };

          customerQuoteItems.push(newCustomerQuoteItem);
        }

        newChoiceGroups.push({
          customerQuoteItems,
          id,
          canBeUnselectable,
          mustAskClient,
        });
      }
    });

    newChoiceGroups.sort(orderChoiceGroups);

    let fistSingleChoiceAssigned = false;
    let fistMultipleChoiceAssigned = false;

    for (let i = 0; i < newChoiceGroups.length; i += 1) {
      const newChoiceGroup = newChoiceGroups[i];

      if (newChoiceGroup.customerQuoteItems
        && newChoiceGroup.customerQuoteItems.length > 1
        && !fistMultipleChoiceAssigned
      ) {
        newChoiceGroup.firstMultipleChoice = true;
        fistMultipleChoiceAssigned = true;
      } else if (newChoiceGroup.customerQuoteItems
        && newChoiceGroup.customerQuoteItems.length === 1
        && !fistSingleChoiceAssigned
      ) {
        newChoiceGroup.firstSingleChoice = true;
        fistSingleChoiceAssigned = true;
      }
    }

    let lineIndex = 1;

    newKeepGroups.forEach((keepGroup) => {
      keepGroup.lineIndex = lineIndex;

      lineIndex += 1;
    });

    newChoiceGroups.forEach((choiceGroup) => {
      choiceGroup.lineIndex = lineIndex;

      lineIndex += 1;
    });

    secondaryOptionsGroupForUI[secondaryKey] = {
      [parentActionId]: {
        choiceGroups: newChoiceGroups,
        keepGroups: newKeepGroups,
      },
    };
  });

  return { secondaryOptionsForUI: secondaryOptionsGroupForUI, needToAskForSecondaryOptions };
};


const getClientOptions = (customerQuoteItems, mainProductType, isExtendCQ, allowNoActionOptions = true, forcedInitialFirstLevelActionIfNecessary = null, forcedLandLineActionIfNecessary = null ) => {
  const mainOptionsFiltered = filterSelectionsFirstLevel(customerQuoteItems, forcedInitialFirstLevelActionIfNecessary);

  const newMainOptions = [];
  const newSecondaryOptions = {};
  let forcedSecondarySelection = null;

  mainOptionsFiltered.forEach((mainOptionFiltered) => {
    const {
      actionId,
      clientPhoneNumberToBeAppliedTo,
      cqsiId,
      choices,
      productOffering,
    } = mainOptionFiltered;

    const name = getProductOfferingTextByType(
      productOffering,
      TEXT_TYPES_CODES.ORDINARY,
    );
    let description = getProductOfferingTextByType(
      productOffering,
      TEXT_TYPES_CODES.BRIEF,
    );

    if (isExtendCQ && mainProductType === PRODUCT_TYPES.ADDITIONAL_MOBILE) {
      description = `${name}: ${description}`;
    }

    const newMainOption = {
      actionId,
      clientPhoneNumberToBeAppliedTo,
      cqsiId,
      description,
      productOfferingName: name,
      productType: mainProductType,
    };

    // Get secondaryOptions associated to this mainOption
    if (choices && Array.isArray(choices) && choices.length > 0) {
      choices.forEach((choice) => {
        const { productOfferingTypes, customerQuotePossibleActions } = choice;
        const productType = getProductTypeByProductOfferingTypes(productOfferingTypes);

        const cqPossibleActions = [];

        customerQuotePossibleActions.forEach((customerQuotePossibleAction) => {
          const {
            customerQuoteItems: cqItems,
            id,
            maxSelectionGroup,
            minSelectionGroup,
          } = customerQuotePossibleAction;
          let forcedAction = null;
          if(productType === PRODUCT_TYPES.LAND_LINE && forcedLandLineActionIfNecessary){
            forcedAction = forcedLandLineActionIfNecessary;
          }
          const cqItemsFiltered = filterSelectionsSecondLevel(cqItems, forcedAction);

          if(forcedAction && cqItemsFiltered.length === 1){
            const cqItemFound = cqItemsFiltered.find(cqItem => cqItem.actionId === forcedAction);
            if(cqItemFound){
              forcedSecondarySelection = [{
                customerQuoteItems: [{ clientPhoneNumberToBeAppliedTo: null, cqsiId: cqItemFound.cqsiId }],
                id, productType, actionId: forcedAction, selectedByClient: true,
              }];
            }
          }

          const maxSelection = parseInt(maxSelectionGroup, 10);
          let minSelection = parseInt(minSelectionGroup, 10);

          for (let i = 0; i < maxSelection; i += 1) {
            const newCqPossibleAction = {
              customerQuoteItems: cqItemsFiltered,
              id,
              canBeUnselectable: (maxSelection > minSelection && minSelection <= 0),
            };

            cqPossibleActions.push(newCqPossibleAction);

            minSelection -= 1;
          }
        });
        if (cqPossibleActions.length > 0) {
          newSecondaryOptions[productType] = {
            choiceGroups: cqPossibleActions,
            parentActionId: actionId,
          };
        }
      });
    }

    newMainOptions.push(newMainOption);
  });
  // end clean mainOptions

  const mainOptionsForUI = getMainClientOptionsForUI(newMainOptions);
  const { secondaryOptionsForUI, needToAskForSecondaryOptions } = getSecondaryClientOptionsForUI(newSecondaryOptions, allowNoActionOptions, mainProductType);

  return {
    mainOptions: newMainOptions,
    mainOptionSelected: mainOptionsForUI.mainOptionSelected,
    secondaryOptions: newSecondaryOptions,
    secondarySelection: forcedSecondarySelection || null,
    mainOptionsForUI,
    secondaryOptionsForUI,
    needToAskForSecondaryOptions,
  };
};

const normalizeInitOrExtendCQ = (response, idPO, isExtendCQ, allowNoActionOptions = true, forcedInitialFirstLevelActionIfNecessary = null, forcedLandLineActionIfNecessary = null ) => {
  const {
    customerQuoteId,
    selectionGroups,
    productOfferingTypes,
  } = response;

  let { customerQuoteItems } = response;

  // Get productType normalized
  const productType = getProductTypeByProductOfferingTypes(productOfferingTypes);

  // Get productOffering texts
  const productOfferingInfo = findProductOfferingById(response, idPO);

  let productOfferingName = null;
  let productOfferingBriefText = null;

  if (productOfferingInfo) {
    productOfferingName = getProductOfferingTextByType(
      productOfferingInfo,
      TEXT_TYPES_CODES.ORDINARY,
    );

    productOfferingBriefText = getProductOfferingTextByType(
      productOfferingInfo,
      TEXT_TYPES_CODES.BRIEF,
    );
  }

  // End get productOffering texts

  if (selectionGroups && Array.isArray(selectionGroups)) {
    const firstSelectionGroup = selectionGroups[0];
    ({ customerQuoteItems } = firstSelectionGroup);
  }

  if (!customerQuoteItems || customerQuoteItems.length === 0) {
    return null;
  }

  let isMaintainingPromotion = false;
  const product = customerQuoteItems[0].productOffering;
  if (product) {
    const { maintainedPromotions, productPromotions } = product;
    isMaintainingPromotion = (
      maintainedPromotions !== null
      && productPromotions !== null
      && Array.isArray(maintainedPromotions)
      && Array.isArray(productPromotions)
      && maintainedPromotions.length > 0
      && productPromotions.length === 0
    );
  }

  const {
    mainOptions,
    mainOptionSelected,
    mainOptionsForUI,
    secondaryOptions,
    secondaryOptionsForUI,
    secondarySelection,
    needToAskForSecondaryOptions,
  } = getClientOptions(customerQuoteItems, productType, isExtendCQ, allowNoActionOptions, forcedInitialFirstLevelActionIfNecessary, forcedLandLineActionIfNecessary);

  return {
    cqId: customerQuoteId,
    mainOptions,
    mainOptionSelected,
    secondaryOptions,
    secondarySelection,
    mainOptionsForUI,
    secondaryOptionsForUI,
    productOfferingName,
    productType,
    productOfferingBriefText,
    needToAskForSecondaryOptions,
    isMaintainingPromotion,
  };
};


// END NEW CODE

export function* initCQ(params, nonFiberCoverage = false) {
  const {
    productOfferings,
    actualProductOffering,
    allPOsToBuy,
    productId,
    promotions,
    forzarErrorMigra,
    subType,
    parentProductId,
    locationId,
    reduxUpdate,
    normalizeHttpErrors,
    errorCoverageObj,
    incompatibleProductsErrorToHandle,
    buyProductOfferingAltWhenErrors,
    saveErrorWhenProductOfferingChanged,
    allowNoActionOptions,
    forcedInitialFirstLevelActionIfNecessary,
    forcedLandLineActionIfNecessary,
    productOfferingsToActivate,
    productsToDeactivate,
    customerInquirySpec
  } = params;

  try {
    const { successUpdate } = reduxUpdate;
    const args = {
      productOffering: productOfferings[0],
    };
    if (productId) {
      args.productId = productId;
    }
    if (promotions) {
      args.promotions = promotions;
    }
    if (forzarErrorMigra) {
      args.forzarErrorMigra = forzarErrorMigra;
    }
    if (subType) {
      args.subType = subType;
    }
    if (parentProductId) {
      args.parentProductId = parentProductId;
    }
    if (locationId) {
      args.locationId = locationId;
    }
    if (productOfferingsToActivate) {
      args.productOfferingsToActivate = productOfferingsToActivate;
    }
    if (productsToDeactivate) {
      args.productsToDeactivate = productsToDeactivate;
    }
    if (typeof customerInquirySpec !== 'undefined') {
      args.customerInquirySpec = customerInquirySpec;
    }

    const context = yield select(contextStore);
    const response = yield call(initCQAda, args, context);
    const normalizedResponse = normalizeInitOrExtendCQ(response, args.productOffering, false, allowNoActionOptions, forcedInitialFirstLevelActionIfNecessary, forcedLandLineActionIfNecessary);
    
    if (!normalizedResponse) {
      throw new Error();
    }
    const newAllPOsToBuy = [...allPOsToBuy];
    if(actualProductOffering && allPOsToBuy && actualProductOffering !== args.productOffering){
      const oldProductOfferingIndex = newAllPOsToBuy.indexOf(actualProductOffering);
      newAllPOsToBuy[oldProductOfferingIndex] = args.productOffering;
      normalizedResponse.newActualProductOffering = args.productOffering;
    }
    normalizedResponse.newAllPOsToBuy = newAllPOsToBuy;
    normalizedResponse.productOffering = args.productOffering;
    yield put(successUpdate(normalizedResponse));

    normalizedResponse.nonFiberCoverage = nonFiberCoverage;

    return normalizedResponse;
  } catch (error) {
    const { errorUpdate } = reduxUpdate;

    if (error?.response?.error?.codigoErrorNegocio
      && (error.response.error.codigoErrorNegocio === WEBSERVICE_ERRORS.WITHOUT_COVERAGE || error.response.error.codigoErrorNegocio === WEBSERVICE_ERRORS.WITHOUT_COVERAGE_ADDRESS)
    ) {
      if (productOfferings[1]) {
        const newProductOfferings = [...productOfferings];
        newProductOfferings.shift();
        const newParams = {
          ...params,
          productOfferings: newProductOfferings,
        };

        return yield call(initCQ, newParams, true);
      }

      yield put(errorUpdate(errorCoverageObj));

      throw error;
    }else if (
      incompatibleProductsErrorToHandle
      && Array.isArray(incompatibleProductsErrorToHandle)
      && error?.response?.error?.codigoErrorNegocio
      && incompatibleProductsErrorToHandle.includes(error.response.error.codigoErrorNegocio)
    ) {
      throw error;
    } else if (
      buyProductOfferingAltWhenErrors
      && error?.response?.error?.codigoErrorNegocio
      && buyProductOfferingAltWhenErrors.includes(error.response.error.codigoErrorNegocio)
    ) {
      if (productOfferings[1]) {
        const newProductOfferings = [...productOfferings];
        newProductOfferings.shift();
        const newParams = {
          ...params,
          productOfferings: newProductOfferings,
        };
        if(saveErrorWhenProductOfferingChanged){
          yield put(saveErrorWhenProductOfferingChanged(error.response.error.codigoErrorNegocio));
        }
        return yield call(initCQ, newParams, false);
      }
      const errorNormalized = yield call(
        normalizeHttpErrors,
        WEB_SERVICES.INIT_CQ,
        error,
      );
      if (errorUpdate) {
        yield put(errorUpdate(errorNormalized));
      }

      throw error;
    } else {
      const errorNormalized = yield call(
        normalizeHttpErrors,
        WEB_SERVICES.INIT_CQ,
        error,
      );
      if (errorUpdate) {
        yield put(errorUpdate(errorNormalized));
      }

      throw error;
    }
  }
}


export function* extendCQ(params) {
  const {
    reduxUpdate,
    normalizeHttpErrors,
    productOffering,
    promotions,
    cqId,
    preSelectedOptions,
    productIdDepend,
  } = params;
  try {
    const { successUpdate } = reduxUpdate;

    const args = {
      productOffering,
      cqId,
      productIdDepend,
    };
    if (promotions) {
      args.promotions = promotions;
    }
    if (productIdDepend) {
      args.productIdDepend = productIdDepend;
    }

    const context = yield select(contextStore);
    const response = yield call(extendCQAda, args, context);

    let forcedInitialFirstLevelActionIfNecessary = null;
    if(preSelectedOptions?.mainOptionsObj?.mainOptionSelected){
      forcedInitialFirstLevelActionIfNecessary = preSelectedOptions.mainOptionsObj.mainOptionSelected;
    }

    const normalizedResponse = normalizeInitOrExtendCQ(response, productOffering, true, false, forcedInitialFirstLevelActionIfNecessary);

    if (!normalizedResponse) {
      throw new Error();
    }

    normalizedResponse.productOffering = args.productOffering;
    yield put(successUpdate(normalizedResponse));

    return normalizedResponse;
  } catch (error) {
    const { errorUpdate } = reduxUpdate;

    const errorNormalized = yield call(
      normalizeHttpErrors,
      WEB_SERVICES.EXTEND_CQ,
      error,
    );
    if (errorUpdate) {
      yield put(errorUpdate(errorNormalized));
    }

    throw error;
  }
}
